import React from 'react'
import { Accordion } from "react-bootstrap";
import { PlusIcon } from "../../../../../styles/img/svg/PlusIcon";
import { UiTable } from '../../../components/common/UiTable';
import UiIncentiveHistoryCard from '../../../components/common/UiIncentiveHistoryCard';
import { UiCol, UiSingleRow } from '../../../components/grid-container/GridContainer';
import { UiContentCol } from '../../../components/common/UiPageElements';
import { UiCardTitle } from '../../../components/common/UiCardTitle';
import { UiSalesChainElement, UiSalesChainElementNoBgWr } from '../../../components/common/UiSalesChainElements';
import Avatar from '../../../../../styles/img/Avatar.png';

export default function LeagueTableIndividual(props) {

    const TableHeaders = [
        { id: 1, th: 'Rank' },
        { id: 2, th: 'Name' },
        { id: 3, th: 'Score' },
        { id: 4, th: 'Location' },
        { id: 5, th: 'Rewards' },
    ];

    return (
        <>
            <div className="sb-accordion-wrapper sb-accordion-league-table">
                <Accordion>
                    <Accordion.Item eventKey="0" key="0">
                        <div className="d-flex">

                            <UiCol lg="12" className={props.className}>
                                <UiContentCol>
                                    <Accordion.Header>
                                        <div className='sb-league-tabl-sec__header'>
                                            <h4>League Table</h4>
                                            <p>More than 400+ new members</p>
                                        </div>
                                        <span className="sb-accordion-wrapper__plus"><PlusIcon /></span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <UiSingleRow>
                                            <UiCol lg="12" className="sb-league-table-top-heading">
                                                <h3>FINAL</h3>
                                            </UiCol>
                                            <UiCol lg="7">
                                                <div className='sb-league-tabl-sec__incentive-joined-sec'>
                                                    <UiTable className="sb-white-bg-table sb-league-table-individual" tableHeader={TableHeaders}>
                                                        {/* <tr>
                                                            <td >
                                                                <div>
                                                                    1
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div>
                                                                    <img src={Avatar} />
                                                                    <span>
                                                                        <h4>Brad Simmons</h4>
                                                                        <p>Lorem Epsum</p>
                                                                    </span>

                                                                </div>
                                                            </td>
                                                            <td >
                                                                <h4>146</h4>
                                                                <p>Confirmed</p>
                                                            </td>
                                                            <td >
                                                                <h4>London</h4>
                                                                <p>UK</p>
                                                            </td>
                                                            <td>
                                                                <h4>Intertico</h4>
                                                                <p>Sales</p>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td >
                                                                <div>
                                                                    1
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div>
                                                                    <img src={Avatar} />
                                                                    <span>
                                                                        <h4>Brad Simmons</h4>
                                                                        <p>Lorem Epsum</p>
                                                                    </span>

                                                                </div>
                                                            </td>
                                                            <td >
                                                                <h4>146</h4>
                                                                <p>Confirmed</p>
                                                            </td>
                                                            <td >
                                                                <h4>London</h4>
                                                                <p>UK</p>
                                                            </td>
                                                            <td>
                                                                <h4>Intertico</h4>
                                                                <p>Sales</p>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td >
                                                                <div>
                                                                    1
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div>
                                                                    <img src={Avatar} />
                                                                    <span>
                                                                        <h4>Brad Simmons</h4>
                                                                        <p>Lorem Epsum</p>
                                                                    </span>

                                                                </div>
                                                            </td>
                                                            <td >
                                                                <h4>146</h4>
                                                                <p>Confirmed</p>
                                                            </td>
                                                            <td >
                                                                <h4>London</h4>
                                                                <p>UK</p>
                                                            </td>
                                                            <td>
                                                                <h4>Intertico</h4>
                                                                <p>Sales</p>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td >
                                                                <div>
                                                                    1
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div>
                                                                    <img src={Avatar} />
                                                                    <span>
                                                                        <h4>Brad Simmons</h4>
                                                                        <p>Lorem Epsum</p>
                                                                    </span>

                                                                </div>
                                                            </td>
                                                            <td >
                                                                <h4>146</h4>
                                                                <p>Confirmed</p>
                                                            </td>
                                                            <td >
                                                                <h4>London</h4>
                                                                <p>UK</p>
                                                            </td>
                                                            <td>
                                                                <h4>Intertico</h4>
                                                                <p>Sales</p>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td >
                                                                <div>
                                                                    1
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div>
                                                                    <img src={Avatar} />
                                                                    <span>
                                                                        <h4>Brad Simmons</h4>
                                                                        <p>Lorem Epsum</p>
                                                                    </span>

                                                                </div>
                                                            </td>
                                                            <td >
                                                                <h4>146</h4>
                                                                <p>Confirmed</p>
                                                            </td>
                                                            <td >
                                                                <h4>London</h4>
                                                                <p>UK</p>
                                                            </td>
                                                            <td>
                                                                <h4>Intertico</h4>
                                                                <p>Sales</p>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td >
                                                                <div>
                                                                    1
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div>
                                                                    <img src={Avatar} />
                                                                    <span>
                                                                        <h4>Brad Simmons</h4>
                                                                        <p>Lorem Epsum</p>
                                                                    </span>

                                                                </div>
                                                            </td>
                                                            <td >
                                                                <h4>146</h4>
                                                                <p>Confirmed</p>
                                                            </td>
                                                            <td >
                                                                <h4>London</h4>
                                                                <p>UK</p>
                                                            </td>
                                                            <td>
                                                                <h4>Intertico</h4>
                                                                <p>Sales</p>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td >
                                                                <div>
                                                                    1
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div>
                                                                    <img src={Avatar} />
                                                                    <span>
                                                                        <h4>Brad Simmons</h4>
                                                                        <p>Lorem Epsum</p>
                                                                    </span>

                                                                </div>
                                                            </td>
                                                            <td >
                                                                <h4>146</h4>
                                                                <p>Confirmed</p>
                                                            </td>
                                                            <td >
                                                                <h4>London</h4>
                                                                <p>UK</p>
                                                            </td>
                                                            <td>
                                                                <h4>Intertico</h4>
                                                                <p>Sales</p>
                                                            </td>
                                                        </tr> */}


                                                    </UiTable>
                                                </div>
                                            </UiCol>
                                            <UiCol lg="5">

                                                <UiContentCol>
                                                    <UiIncentiveHistoryCard
                                                        heading="My score is made up from:"
                                                        amount="£443.50"
                                                        qtyTitle="Latest sales = "
                                                        rightTitle="Target sales = "
                                                        rtVal="£25,000"
                                                    >
                                                        <UiSalesChainElementNoBgWr>
                                                            <UiSalesChainElement isActive={true} salesStatus="Entry confirmed for sale" salesId="NR7107463" date="22 Nov 2022" />
                                                            <UiSalesChainElement isActive={true} salesStatus="Entry confirmed for sale" salesId="NR7107463" date="22 Nov 2022" />
                                                            <UiSalesChainElement salesStatus="Verifying Entry for sale" salesId="NR7107463" date="22 Nov 2022" />
                                                            <UiSalesChainElement salesStatus="Verifying Entry for sale" salesId="NR7107463" date="22 Nov 2022" />
                                                            <UiSalesChainElement salesStatus="Verifying Entry for sale" salesId="NR7107463" date="22 Nov 2022" />
                                                            <UiSalesChainElement salesStatus="Verifying Entry for sale" salesId="NR7107463" date="22 Nov 2022" />

                                                        </UiSalesChainElementNoBgWr>
                                                    </UiIncentiveHistoryCard>
                                                </UiContentCol>


                                            </UiCol>
                                        </UiSingleRow>
                                    </Accordion.Body>
                                </UiContentCol>
                            </UiCol>
                        </div>
                    </Accordion.Item>

                </Accordion>
            </div>

        </>
    )
}
